let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ZJp6")).then(() => parcelRequire('kMyu3'));